export { DictionaryLayout } from './dictionaries-layout/dictionaries.component';
